import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { track } from '../_core/common/eventTracking/tracker';
import { logRavenException } from '../_core/utils/errors';
import { trackUpgradePointTooltipFailure } from '../_core/utils/metricUtils';
import { writeUpgradeConfigToLocalStorage } from '../_core/utils/upgradeConfigCache';
import { getUpgradePageUrl } from '../_core/utils/upgradePageRedirect';
import { getTrackingProperties, getUpgradePointPromise } from './utils';
import { jsx as _jsx } from "react/jsx-runtime";
export const useUpgradePointTooltipData = (upgradeKey, enableTooltip = true) => {
  const [wasTooltipOpened, setWasTooltipOpened] = useState(false);
  const [data, setData] = useState({
    upgradeConfig: undefined,
    hasError: false
  });
  const upgradePointPromise = useMemo(() => {
    return getUpgradePointPromise({
      upgradeKey
    });
  }, [upgradeKey]);
  useEffect(() => {
    if (data.upgradeConfig && wasTooltipOpened === true) {
      track('interaction', Object.assign({
        action: 'viewed upgrade tooltip'
      }, getTrackingProperties(data.upgradeConfig)));
    }
  }, [data.upgradeConfig, wasTooltipOpened]);
  useEffect(() => {
    if (enableTooltip && wasTooltipOpened) {
      upgradePointPromise.then(upgradeConfig => {
        if (upgradeConfig) {
          setData({
            upgradeConfig,
            hasError: false
          });
        }
      }).catch(error => {
        console.error(error);
        setData({
          upgradeConfig: undefined,
          hasError: true
        });
        trackUpgradePointTooltipFailure(upgradeKey);
        logRavenException({
          customMessage: 'Failed to fetch upgrade point in useUpgradePointTooltipData',
          error,
          uniqueId: upgradeKey,
          fingerprint: ['useUpgradePointTooltipData']
        });
      });
    }
  }, [upgradePointPromise, upgradeKey, enableTooltip, wasTooltipOpened]);

  // Tooltip Content
  const Content = useCallback(() => {
    return /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "upgradePointTooltip.upgradePageLink_jsx",
      elements: {
        Link: props => /*#__PURE__*/_jsx(Link, Object.assign({
          href: getUpgradePageUrl(upgradeKey),
          target: "_blank",
          onClick: () => {
            if (data.upgradeConfig) {
              writeUpgradeConfigToLocalStorage(data.upgradeConfig);
            }
            track('interaction', Object.assign({
              action: 'clicked upgrade point',
              clickedTooltipLink: true
            }, getTrackingProperties(data.upgradeConfig)));
          }
        }, props))
      }
    });
  }, [data, upgradeKey]);

  // Tooltip open handler
  const onOpenChange = useCallback(event => {
    var _event$target;
    if (event !== null && event !== void 0 && (_event$target = event.target) !== null && _event$target !== void 0 && _event$target.value && !wasTooltipOpened) {
      var _event$target2;
      setWasTooltipOpened(event === null || event === void 0 || (_event$target2 = event.target) === null || _event$target2 === void 0 ? void 0 : _event$target2.value);
    }
  }, [wasTooltipOpened]);
  return {
    onOpenChange,
    Content,
    disabled: !enableTooltip,
    data
  };
};